var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":40,"color":("" + (_vm.$store.getters.theme ? _vm.$store.getters.theme[2] : '#6b6b6b'))}})}
var staticRenderFns = []

export { render, staticRenderFns }